import React, { useState, useEffect } from 'react';
import XCard from '../../components/Cards/XCard';
import YCard from '../../components/Cards/YCard';
import JobTrendCard from '../../components/Cards/JobTrendCard';
import JobStatusCard from '../../components/Cards/JobStatusCard';
import serviceProvider from '../../assets/serviceProvider.png';
import homeOwner from '../../assets/homeOwner.png';
import axios from 'axios';

const Dashboard = () => {
    const [jobStatusCount, setJobStatusCount] = useState({
        COMPLETED: 0,
        UNPAID: 0,
        IN_PROGRESS: 0,
        PAID: 0,
        CREATED: 0
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                
                // FIXED: Get token from localStorage
                const token = localStorage.getItem('token');
                
                if (!token) {
                    setError('Authentication required');
                    setLoading(false);
                    return;
                }
                
                // FIXED: Get job status counts with proper auth header
                const jobsResponse = await axios.get(
                    'https://jobmanagement-497524552274.us-central1.run.app/api/jobs/status-count',
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    }
                );
                
                const data = jobsResponse.data;
                
                setJobStatusCount({
                    COMPLETED: data.COMPLETED || 0,
                    UNPAID: data.UNPAID || 0,
                    IN_PROGRESS: data.IN_PROGRESS || 0,
                    PAID: data.PAID || 0,
                    CREATED: data.CREATED || 0
                });
                
                setError(null);
            } catch (error) {
                console.error('Error fetching job status:', error);
                setError(error.message);
                
                // Use mock data for development/testing purposes
                setJobStatusCount({
                    COMPLETED: 15,
                    UNPAID: 8,
                    IN_PROGRESS: 12,
                    PAID: 25,
                    CREATED: 10
                });
            } finally {
                setLoading(false);
            }
        };
        
        fetchData();
    }, []);

    const jobs = (
        <div>
            <p>Number of</p>
            <p style={{ padding: '5px 0px 5px 25px' }}>Jobs</p>
            <p> to be settled</p>
        </div>
    );

    const services = (
        <div>
            <p>Number of</p>
            <p style={{ margin: '5px -15px' }}>Service Providers</p>
            <p> to be settled</p>
        </div>
    );

    if (loading && !Object.values(jobStatusCount).some(val => val > 0)) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                <p>Loading dashboard data...</p>
            </div>
        );
    }

    return (
        <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center' }}>
            {error && (
                <div style={{ 
                    position: 'fixed', 
                    top: '10px', 
                    right: '10px',
                    backgroundColor: '#FEE2E2',
                    border: '1px solid #EF4444',
                    borderRadius: '4px',
                    padding: '8px 12px',
                    zIndex: 1000
                }}>
                    {error === 'Authentication required' 
                        ? 'Authentication required to fetch live data. Using sample data.' 
                        : `Error: ${error}. Using sample data.`}
                </div>
            )}
            
            <div style={{ width: '90%', maxWidth: '1200px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <JobTrendCard />
                    <JobStatusCard />
                </div>
                <div
                    style={{
                        display: 'flex',
                        marginTop: '30px',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', width: '47.5%' }}>
                        <XCard
                            num={jobStatusCount.IN_PROGRESS}
                            name="Service Providers"
                            color="#E5F5E9"
                            border="#44983C"
                            image={serviceProvider}
                        />
                        <XCard
                            num={jobStatusCount.COMPLETED}
                            name="Home Owners"
                            color="#F0F8F9"
                            border="#3C8C9E"
                            image={homeOwner}
                        />
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            width: '47.5%',
                            justifyContent: 'space-between',
                        }}
                    >
                        <YCard num={jobStatusCount.CREATED} name={jobs} color="#F7E5E8" />
                        <YCard num={jobStatusCount.IN_PROGRESS} name={services} color="#FFEFD9" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;